/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LogoutAllUserSessionsMutationVariables = {
    userId: string;
};
export type LogoutAllUserSessionsMutationResponse = {
    readonly logoutAllUserSessions: {
        readonly success: boolean;
    } | null;
};
export type LogoutAllUserSessionsMutation = {
    readonly response: LogoutAllUserSessionsMutationResponse;
    readonly variables: LogoutAllUserSessionsMutationVariables;
};



/*
mutation LogoutAllUserSessionsMutation(
  $userId: ID!
) {
  logoutAllUserSessions(userId: $userId) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "LogoutAllUserSessions",
    "kind": "LinkedField",
    "name": "logoutAllUserSessions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutAllUserSessionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogoutAllUserSessionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "38d0437f330d89eba588232fd9847c64",
    "id": null,
    "metadata": {},
    "name": "LogoutAllUserSessionsMutation",
    "operationKind": "mutation",
    "text": "mutation LogoutAllUserSessionsMutation(\n  $userId: ID!\n) {\n  logoutAllUserSessions(userId: $userId) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '1a23179d19f8715b241b97d5766d8c80';
export default node;
